import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'

iziToast.settings({
  // close: false,
  icon: '',
  pauseOnHover: true,
  timeout: 2000,
  progressBar: true,
  layout: 2,
  position: 'bottomCenter',
  transitionIn: 'bounceInDown',
  transitionOut: 'fadeOut',
  transitionInMobile: 'fadeInUp',
  transitionOutMobile: 'fadeOutDown'
})

export default iziToast
